export default {
  title: '팔천업소고객관리시스템',
};
